var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "jingmaiExam" } }, [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          "align-items": "center",
          "margin-bottom": "10px",
          cursor: "pointer",
          width: "100px"
        },
        on: { click: _vm.goBack }
      },
      [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-left": "10px" } }, [_vm._v("返回")])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("@/assets/images/jingmai/bg.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: require("@/assets/images/jingmai/logo01.png")
                        },
                        on: { click: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("@/assets/images/jingmai/bg.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02",
                        attrs: {
                          src: require("@/assets/images/jingmai/logo02.png")
                        },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginImg,
                          expression: "isShowLoginImg"
                        }
                      ],
                      staticClass: "login"
                    },
                    [
                      _c("img", {
                        staticClass: "homeImg",
                        attrs: {
                          src: require("@/assets/images/jingmai/login.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name"
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text", placeholder: "请输入账号" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password",
                          placeholder: "请输入密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "mima",
                        on: {
                          click: function($event) {
                            _vm.isShowMimaImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowMimaImg,
                            expression: "isShowMimaImg"
                          }
                        ],
                        staticClass: "mima",
                        attrs: {
                          src: require("@/assets/images/jingmai/mima.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logIn",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowRnd,
                          expression: "isShowRnd"
                        }
                      ],
                      staticClass: "loginrnd"
                    },
                    [
                      _c("img", {
                        staticClass: "rndImg",
                        attrs: {
                          src: require("@/assets/images/jingmai/loginrnd.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rnd,
                            expression: "rnd"
                          }
                        ],
                        staticClass: "rnd",
                        attrs: {
                          type: "text",
                          placeholder: "请输入短信验证码"
                        },
                        domProps: { value: _vm.rnd },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.rnd = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "logInRnd",
                        on: { click: _vm.loginInRnd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndex,
                          expression: "isShowLoginIndex"
                        }
                      ],
                      staticClass: "jdbox"
                    },
                    [
                      _c("img", {
                        staticClass: "jdimg",
                        attrs: {
                          src: require("@/assets/images/jingmai/index.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "jdicon",
                        on: { click: _vm.enterJd }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLoginIndexTwo,
                          expression: "isShowLoginIndexTwo"
                        }
                      ],
                      staticClass: "indexbox"
                    },
                    [
                      _c("img", {
                        staticClass: "indeximg",
                        attrs: {
                          src: require("@/assets/images/jingmai/jd.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请点击"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("左侧练习场")]
                          ),
                          _vm._v("中的京麦图标进行登录")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取账号密码。本次模拟练习，请点击下方按钮获取账号密码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = true
                                }
                              }
                            },
                            [_vm._v("获取账号密码")]
                          ),
                          _vm._v(" "),
                          _vm.showPassword
                            ? [
                                _c(
                                  "p",
                                  [
                                    _vm._v("账号（"),
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("账号中间的冒号是英文冒号")
                                    ]),
                                    _vm._v("）：")
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("淘金客服:002")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("密码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("TJ2022")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("勾选“记住密码”")])
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [
                          _c("p", [
                            _vm._v(
                              "首次登录需要找主管获取短信验证码。本次模拟练习，请点击下方按钮获取短信验证码。"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            },
                            [_vm._v("获取短信验证码")]
                          ),
                          _vm._v(" "),
                          _vm.showRnd
                            ? [
                                _c("p", [_vm._v("短信验证码：")]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("font", { attrs: { color: "red" } }, [
                                      _vm._v("6022")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex
                      ? _c("p", [_vm._v("请进入京麦接待中心")])
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isShowWgq,
                          expression: "!isShowWgq"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "gqimg",
                        attrs: {
                          src: require("@/assets/images/jingmai/jd.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "gqbtn",
                        on: {
                          click: function($event) {
                            _vm.showGqImg = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: require("@/assets/images/jingmai/qh.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showGqImg,
                            expression: "showGqImg"
                          }
                        ],
                        staticClass: "gqclick",
                        on: { click: _vm.showWgqImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowWgq,
                          expression: "isShowWgq"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        staticClass: "wgqimg",
                        attrs: {
                          src: require("@/assets/images/jingmai/qhwc.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(2)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "paixubox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne || _vm.isShowFive,
                          expression: "isShowOne || isShowFive"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: require("@/assets/images/jingmai/paixu01.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowOne,
                          expression: "isShowOne"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { mouseover: _vm.showPaixuImgOne }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: require("@/assets/images/jingmai/paixu02.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowTwo,
                          expression: "isShowTwo"
                        }
                      ],
                      staticClass: "pxbtn",
                      on: { click: _vm.showPaixuImgTwo }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: require("@/assets/images/jingmai/paixu03.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowThree,
                          expression: "isShowThree"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { mouseover: _vm.showPaixuImgThree }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: require("@/assets/images/jingmai/paixu04.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFour,
                          expression: "isShowFour"
                        }
                      ],
                      staticClass: "pxclick",
                      on: { click: _vm.showPaixuImgFour }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "sjclick",
                      on: { click: _vm.showPaixuImgFive }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "pximg",
                      attrs: {
                        src: require("@/assets/images/jingmai/paixu05.png")
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _vm.isShowOne ||
                  _vm.isShowTwo ||
                  _vm.isShowThree ||
                  _vm.isShowFour
                    ? _c(
                        "p",
                        [
                          _vm._v("请将客户咨询排序设置为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("\n\t\t\t\t\t\t\t\t\t按等待时间降序")
                          ]),
                          _vm._v("”\n\t\t\t\t\t\t\t")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowFive
                    ? _c(
                        "p",
                        [
                          _vm._v("请切换到"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("数据")
                          ]),
                          _vm._v("功能，查看数据")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zdhfbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: require("@/assets/images/jingmai/zdhf01.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhficon,
                          expression: "isShowZdhficon"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { mouseover: _vm.showZdhf01 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: require("@/assets/images/jingmai/zdhf02.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf01,
                          expression: "isShowZdhf01"
                        }
                      ],
                      staticClass: "zdhficon",
                      on: { click: _vm.showZdhf02 }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "gqimg",
                      attrs: {
                        src: require("@/assets/images/jingmai/zdhf03.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowZdhf02,
                          expression: "isShowZdhf02"
                        }
                      ],
                      staticClass: "zdhf01icon",
                      on: { click: _vm.showZdhf03 }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf03,
                            expression: "isShowZdhf03"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zdhf04.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf02icon",
                          on: { click: _vm.showZdhf04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf04,
                            expression: "isShowZdhf04"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zdhf05.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf03icon",
                          on: { click: _vm.showZdhf05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf05,
                            expression: "isShowZdhf05"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zdhf06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf04icon",
                          on: { click: _vm.showZdhf06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf06,
                            expression: "isShowZdhf06"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zdhf07.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf05icon",
                          on: { click: _vm.showZdhf07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf07,
                            expression: "isShowZdhf07"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zdhf08_bg.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "scrollImg",
                          attrs: {
                            src: require("@/assets/images/jingmai/zdhf08.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "zdhf06input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.zdhf,
                            callback: function($$v) {
                              _vm.zdhf = $$v
                            },
                            expression: "zdhf"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zdhf06icon",
                          on: { click: _vm.showZdhf08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZdhf08,
                            expression: "isShowZdhf08"
                          }
                        ],
                        staticClass: "zdhf02"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zdhf09.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v(
                        "请设置“您好！欢迎光临，请问有什么可以帮到您？”的自动回复"
                      ),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("个人版欢迎语")
                      ]),
                      _vm._v("，并勾选“"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("\n\t\t\t\t\t\t\t\t\t第一次收到顾客消息的回复语")
                      ]),
                      _vm._v("\n\t\t\t\t\t\t\t\t”（记得保存）")
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "kjdybox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy01,
                            expression: "isShowKjdy01"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy01.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy01icon",
                          on: { mouseover: _vm.showKjdy01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy02,
                            expression: "isShowKjdy02"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy02.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "kjdy01icon" }, [
                          _c("input", {
                            staticClass: "btn-file",
                            attrs: { type: "file", accept: ".csv" },
                            on: {
                              change: function($event) {
                                return _vm.tirggerFile($event)
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy03,
                            expression: "isShowKjdy03"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy03.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy04,
                            expression: "isShowKjdy04"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy04.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy02icon",
                          on: { mouseover: _vm.showKjdy02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy05,
                            expression: "isShowKjdy05"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy05.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy03icon",
                          on: { click: _vm.showKjdy03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy06,
                            expression: "isShowKjdy06"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy04.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy07,
                            expression: "isShowKjdy07"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy07.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy08,
                            expression: "isShowKjdy08"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy04.png")
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdy,
                                callback: function($$v) {
                                  _vm.kjdy = $$v
                                },
                                expression: "kjdy"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy09,
                            expression: "isShowKjdy09"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy08.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy10,
                            expression: "isShowKjdy10"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy06.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy11,
                            expression: "isShowKjdy11"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy07.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy12,
                            expression: "isShowKjdy12"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy04.png")
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "kjdy05icon" },
                          [
                            _c("el-input", {
                              staticClass: "kjdy01input",
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.kjdytwo,
                                callback: function($$v) {
                                  _vm.kjdytwo = $$v
                                },
                                expression: "kjdytwo"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy13,
                            expression: "isShowKjdy13"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy09.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy06icon",
                          on: { click: _vm.showKjdy07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy14,
                            expression: "isShowKjdy14"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "kjdyinput",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showKjdy08.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy04icon",
                          on: { click: _vm.showKjdy08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy15,
                            expression: "isShowKjdy15"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy07.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy16,
                            expression: "isShowKjdy16"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy01.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { mouseover: _vm.showKjdy09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy17,
                            expression: "isShowKjdy17"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy10.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy07icon",
                          on: { click: _vm.showKjdy10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy18,
                            expression: "isShowKjdy18"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy11.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy08icon",
                          on: { click: _vm.showKjdy11 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy19,
                            expression: "isShowKjdy19"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy12.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.fenzu,
                            callback: function($$v) {
                              _vm.fenzu = $$v
                            },
                            expression: "fenzu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy09icon",
                          on: { click: _vm.showKjdy12 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy20,
                            expression: "isShowKjdy20"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy11.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy10icon",
                          on: { click: _vm.showKjdy13 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy21,
                            expression: "isShowKjdy21"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy13.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy11icon",
                          on: { click: _vm.showKjdy14 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy22,
                            expression: "isShowKjdy22"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy14.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.xjkjdy,
                            callback: function($$v) {
                              _vm.xjkjdy = $$v
                            },
                            expression: "xjkjdy"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "kjdy04input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.kjbm,
                            callback: function($$v) {
                              _vm.kjbm = $$v
                            },
                            expression: "kjbm"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "kjdy12icon",
                          on: { click: _vm.showKjdy15 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowKjdy23,
                            expression: "isShowKjdy23"
                          }
                        ],
                        staticClass: "kjdy"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/kjdy15.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _vm.isShowKjdyTip01
                    ? _c("div", [
                        _c("p", [_vm._v("导入快捷短语操作练习：")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("请先下载下方的快捷短语表格，并保存在桌面上")
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip02
                    ? _c("p", [_vm._v("请将下载好的快捷短语表格导入到京麦上")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip03
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("鼠标左键")
                          ]),
                          _vm._v("调出"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("发货")
                          ]),
                          _vm._v("的快捷短语，并发送\n\t\t\t\t\t\t\t")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/16")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("在输入框输入“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("/发货")
                          ]),
                          _vm._v("”调出快捷短语，并发送")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowKjdyTip06
                    ? _c("div", [
                        _c("p", [_vm._v("新建一条催付的快捷短语：")]),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语内容："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(
                                "您好！您拍下的商品还未付款，请问您是有什么顾虑吗？"
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("新建快捷短语分组："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          [
                            _vm._v("快捷短语编码："),
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v("催付")
                            ])
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn01,
                            expression: "isShowZjgn01"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zj01.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { mouseover: _vm.showZjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn02,
                            expression: "isShowZjgn02"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zj02.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn01icon",
                          on: { click: _vm.showZjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn03,
                            expression: "isShowZjgn03"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zj03.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn02icon",
                          on: { click: _vm.showZjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn04,
                            expression: "isShowZjgn04"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zj04.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn03icon",
                          on: { dblclick: _vm.showZjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn05,
                            expression: "isShowZjgn05"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zj05.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn04icon",
                          on: { click: _vm.showZjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn06,
                            expression: "isShowZjgn06"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zj06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "zjgn05icon",
                          on: { click: _vm.showZjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowZjgn07,
                            expression: "isShowZjgn07"
                          }
                        ],
                        staticClass: "zjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/zj07.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v("请根据聊天内容，将此顾客转接给状态为“"),
                      _c("font", { attrs: { color: "red" } }, [_vm._v("在线")]),
                      _vm._v("”的售后客服，并选择对应的"),
                      _c("font", { attrs: { color: "red" } }, [
                        _vm._v("转接原因")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 7, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn01,
                            expression: "isShowCjgn01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj01.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { mouseover: _vm.showCjgn01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn02,
                            expression: "isShowCjgn02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj02.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn01icon",
                          on: { click: _vm.showCjgn02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn03,
                            expression: "isShowCjgn03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj03.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn02icon",
                          on: { click: _vm.showCjgn03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn04,
                            expression: "isShowCjgn04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj04.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn05,
                            expression: "isShowCjgn05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj05.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn03icon",
                          on: { click: _vm.showCjgn04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn06,
                            expression: "isShowCjgn06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn04icon",
                          on: { click: _vm.showCjgn05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn07,
                            expression: "isShowCjgn07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj07.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn05icon",
                          on: { click: _vm.showCjgn06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn08,
                            expression: "isShowCjgn08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj08.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn09,
                            expression: "isShowCjgn09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn06icon",
                          on: { click: _vm.showCjgn07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn10,
                            expression: "isShowCjgn10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj09.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn07icon",
                          on: { click: _vm.showCjgn08 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn11,
                            expression: "isShowCjgn11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj10.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn12,
                            expression: "isShowCjgn12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn08icon",
                          on: { click: _vm.showCjgn09 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn13,
                            expression: "isShowCjgn13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj11.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn09icon",
                          on: { click: _vm.showCjgn10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn14,
                            expression: "isShowCjgn14"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj12.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn15,
                            expression: "isShowCjgn15"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn10icon",
                          on: { click: _vm.showCjgn11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn16,
                            expression: "isShowCjgn16"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj13.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn11icon",
                          on: { click: _vm.showCjgn12 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn17,
                            expression: "isShowCjgn17"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj14.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn18,
                            expression: "isShowCjgn18"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj13.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn12icon",
                          on: { click: _vm.showCjgn13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn19,
                            expression: "isShowCjgn19"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj15.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgn13icon",
                          on: { click: _vm.showCjgn14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgn20,
                            expression: "isShowCjgn20"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cj16.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _vm.isShowCjgnTip01
                    ? _c("p", [_vm._v("请添加客服助手插件")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip02
                    ? _c("p", [
                        _vm._v("请查看客户的商品浏览足迹，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请发送符合客户需求的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("金")
                          ]),
                          _vm._v("和"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("银")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip04
                    ? _c("p", [_vm._v("请查看客户的购物车，并推荐合适的商品")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip05
                    ? _c("p", [
                        _vm._v("请查看客户收藏关注的商品，并推荐合适的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip06
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺销量最高，且符合客户需求的商品")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnTip07
                    ? _c("p", [
                        _vm._v("请给客户推荐店铺评价最高，且符合客户需求的商品")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight", 8, "eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cjgnbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx01,
                            expression: "isShowCjgnx01"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx01.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx01icon",
                          on: { click: _vm.showCjgnx01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx02,
                            expression: "isShowCjgnx02"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx02.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx01input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.yunfei,
                            callback: function($$v) {
                              _vm.yunfei = $$v
                            },
                            expression: "yunfei"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx02icon",
                          on: { click: _vm.showCjgnx02 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx03,
                            expression: "isShowCjgnx03"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx03.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx04,
                            expression: "isShowCjgnx04"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx04.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx03icon",
                          on: { click: _vm.showCjgnx03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx05,
                            expression: "isShowCjgnx05"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx05.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx02input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.dizhi,
                            callback: function($$v) {
                              _vm.dizhi = $$v
                            },
                            expression: "dizhi"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx04icon",
                          on: { click: _vm.showCjgnx04 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx06,
                            expression: "isShowCjgnx06"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx05icon",
                          on: { click: _vm.showCjgnx05 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx07,
                            expression: "isShowCjgnx07"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx07.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx08,
                            expression: "isShowCjgnx08"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx06icon",
                          on: { click: _vm.showCjgnx06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx09,
                            expression: "isShowCjgnx09"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx08.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx10,
                            expression: "isShowCjgnx10"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx09.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx07icon",
                          on: { click: _vm.showCjgnx07 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx11,
                            expression: "isShowCjgnx11"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx10.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx08icon",
                          on: { click: _vm.showCjgnx08 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx12,
                            expression: "isShowCjgnx12"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx11.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "cjgnx03input",
                          attrs: { type: "textarea" },
                          model: {
                            value: _vm.beizhu,
                            callback: function($$v) {
                              _vm.beizhu = $$v
                            },
                            expression: "beizhu"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "cjgnx09icon",
                          on: { click: _vm.showCjgnx09 }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowCjgnx13,
                            expression: "isShowCjgnx13"
                          }
                        ],
                        staticClass: "cjgn"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/cjx12.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(8),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip01
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待付款")
                          ]),
                          _vm._v(
                            "的订单可以修改运费。请阅读聊天内容，修改运费金额\n\t\t\t\t\t\t\t"
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip02
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("待出库")
                          ]),
                          _vm._v(
                            "的订单，可以修改客户收货信息。请根据聊天内容，修改客户收货信息"
                          ),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t（注意：如果提示输入的内容不正确，那就是地址的省、市、区、街道重复了）"
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip03
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("收货信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip04
                    ? _c(
                        "p",
                        [
                          _vm._v("请和客户核对"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单信息")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip05
                    ? _c(
                        "p",
                        [
                          _vm._v("假设店铺规定有关发票的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("1级")
                          ]),
                          _vm._v("；有关顺丰快递的备注，等级为"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("2级\n\t\t\t\t\t\t\t\t")
                          ]),
                          _vm._v("。请根据聊天内容，给此客户添加对应的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("订单备注")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowCjgnxTip06
                    ? _c(
                        "p",
                        [
                          _vm._v("请编辑备注内容为："),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("要纸质发票")
                          ]),
                          _vm._v("，并选择对应的等级")
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-nine", 9, "nine")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "nine" },
            attrs: { id: "tab-nine-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-nine" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcjmbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm01,
                            expression: "isShowTcjm01"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/tc01.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm01icon",
                          on: { click: _vm.showTcjm01 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm02,
                            expression: "isShowTcjm02"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/tc02.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm02icon",
                          on: { click: _vm.showTcjm02 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm03,
                            expression: "isShowTcjm03"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/tc03.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm03icon",
                          on: { click: _vm.showTcjm03 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm04,
                            expression: "isShowTcjm04"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/tc04.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm04icon",
                          on: { click: _vm.showTcjm04 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm05,
                            expression: "isShowTcjm05"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/tc05.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "tcjm05icon",
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              return _vm.showTcjm05.apply(null, arguments)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjmImg",
                          attrs: {
                            src: require("@/assets/images/jingmai/tc06.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isShowTcjm06,
                              expression: "isShowTcjm06"
                            }
                          ],
                          staticClass: "tcjm06icon",
                          on: { click: _vm.showTcjm06 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowTcjm07,
                            expression: "isShowTcjm07"
                          }
                        ],
                        staticClass: "tcjm"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/jingmai/tc07.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _vm.isShowTcjmTip01
                    ? _c(
                        "p",
                        [
                          _vm._v("请将状态切换为“"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("离线")
                          ]),
                          _vm._v("”")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip02
                    ? _c("p", [_vm._v("请关闭接待中心")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowTcjmTip03
                    ? _c("p", [_vm._v("请在右下角找到京麦的图标，并退出京麦")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-nine" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tip",
                        staticStyle: { width: "400px", height: "270px" }
                      },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("实操通关，进入下一关吧")]),
                        _vm._v(" "),
                        _c("p", [
                          _c(
                            "a",
                            {
                              staticClass: "startstudy",
                              on: {
                                click: function($event) {
                                  return _vm.studyNext("#tab-ten", 10, "ten")
                                }
                              }
                            },
                            [_vm._v("GO，下一关")]
                          )
                        ])
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "ten" },
            attrs: { id: "tab-ten-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-nine" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-ten" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "dmqdbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 1 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 1 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom01.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 1 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 1 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom02.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 1,
                          expression: "duomaiStep == 1"
                        }
                      ],
                      staticClass: "desktop-hover",
                      on: {
                        click: function() {
                          _vm.duomaiStep = 2
                          _vm.mouseFocusDM = false
                        },
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 2 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 2 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom03.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 2 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 2 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom04.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 2,
                          expression: "duomaiStep == 2"
                        }
                      ],
                      staticClass: "jingmai-hover",
                      on: {
                        click: function() {
                          _vm.duomaiStep = 3
                          _vm.mouseFocusDM = false
                        },
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 3 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 3 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom05.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 3 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 3 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom06.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 3,
                          expression: "duomaiStep == 3"
                        }
                      ],
                      staticClass: "login-hover",
                      on: {
                        click: function() {
                          _vm.duomaiStep = 4
                          _vm.mouseFocusDM = false
                        },
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 4 && !_vm.mouseFocusDM,
                          expression: "duomaiStep == 4 && !mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom07.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 4 && _vm.mouseFocusDM,
                          expression: "duomaiStep == 4 && mouseFocusDM"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom08.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 4,
                          expression: "duomaiStep == 4"
                        }
                      ],
                      staticClass: "dd-hover",
                      on: {
                        click: _vm.lastStep,
                        mouseenter: function($event) {
                          _vm.mouseFocusDM = true
                        },
                        mouseleave: function($event) {
                          _vm.mouseFocusDM = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 5,
                          expression: "duomaiStep == 5"
                        }
                      ],
                      staticClass: "desktop-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom01.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.duomaiStep == 5,
                          expression: "duomaiStep == 5"
                        }
                      ],
                      staticClass: "dmjm-img",
                      attrs: {
                        src: require("@/assets/images/jingmai/duom09.png"),
                        alt: ""
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(10),
                  _vm._v(" "),
                  _vm.duomaiStep == 1
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("打开左侧")
                          ]),
                          _vm._v("练习场中的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("多脉客服助手")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 2
                    ? _c("p", [_vm._v("启动京麦")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 3
                    ? _c("p", [_vm._v("点击登录")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 4
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("点击右上角的咚咚图标，进入接待中心")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-ten" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tip",
                        staticStyle: { width: "400px", height: "270px" }
                      },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t你已完成\n\t\t\t\t\t\t\t\t"
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.myExamNum))
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t次，需完成\n\t\t\t\t\t\t\t\t"
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.examNum))
                                ]),
                                _vm._v("\n\t\t\t\t\t\t\t\t次\n\t\t\t\t\t\t\t")
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [_vm._v("恭喜您完成所有训练")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "5px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("返回")]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "10px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("继续学习")]
                            )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("1、登录京麦")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、状态切换")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、客户列表+数据统计")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("4、自动回复设置")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("5、快捷短语导入和使用")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、转接功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、插件功能（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("7、插件功能（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-nine" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("8、退出京麦")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-ten" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("9、从多脉打开京麦")
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("请将状态切换为“在线”")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-708c9a77", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-708c9a77","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/jingmaiExam.vue
// module id = 1730
// module chunks = 0